<template lang="html">
  <div
    :class="[ `text-field--${size}` ]"
    class="text-field"
  >
    <div
      v-if="$slots.before"
      class="text-field__slot text-field__before"
    >
      <slot name="before" />
    </div>
    <label :for="name" class="screen-reader-only">{name}</label>
    <input
      :name="name"
      :value="value"
      class="text-field__input"
      type="text"
      v-on="hooks"
    >
    <div
      v-if="$slots.after"
      class="text-field__slot text-field__after"
    >
      <slot name="after" />
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    size: VueTypes.oneOf(['default', 'large']).def('default')
  },
  data () {
    return {
      hooks: {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value)
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/font-sizes';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';

  .text-field {
    display: flex;
    width: 100%;
    background: gray(5);
    box-sizing: border-box;
    border-radius: 25px;
    overflow: hidden;
  }

  .text-field__input {
    border: none;
    flex: 1;

    &:focus {
      outline: none;
    }
  }

  .text-field__slot {
    display: flex;
    align-items: center;
    padding-left: scale(5);
    padding-right: scale(5);
  }

  .text-field--default {
    .text-field__input {
      font-size: font-size(0);
      padding: scale(3) scale(5);
    }
  }

  .text-field--large {
    .text-field__input {
      font-size: font-size(1);
      padding: scale(5);
    }
  }
</style>
